import React from 'react';
import i18n from 'i18';

// @mui
import { TableCell } from '@mui/material';

import Label from 'components/label';
import helper from '../../utils/helper';

export default class GridStatusCell extends React.Component {
    render() {
        const { value } = this.props;
        const color = helper.getStatusColor(value);

        return (
            <TableCell align="left">
                <Label color={color} sx={{ fontSize: 12 }}>
                    {i18n.t(`enums.${value}`)}
                </Label>
            </TableCell>
        );
    }
}
